import React, { FC } from 'react';

import { ModalFooter, ModalTitle, ModalHeader } from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { Switch } from '@epoch-ui/components/Switch/switch';

import { useGuestSideSheetContext } from '../../../../guestSideSheetContext';
import { usePlusOneRsvpControlModalContext } from '../plusOneRsvpControlContext';

export const ConfirmChangeToWaitlistedContent: FC = () => {
  const { sendNotifications, setSendNotifications, navigation } =
    usePlusOneRsvpControlModalContext();
  const { selectedSession } = useGuestSideSheetContext();

  const label = selectedSession ? 'session' : 'event';

  return (
    <>
      <ModalHeader className="tw-m-0 tw-text-black">
        <ModalTitle className="tw-mb-0 tw-text-2xl tw-font-medium">Change RSVP?</ModalTitle>
      </ModalHeader>
      <div className="tw-space-y-4 tw-text-black">
        <span className="tw-leading-5">
          This {label} is full. If you change this guest&apos;s RSVP to waitlisted, they&apos;ll
          lose their spot for this {label}.
        </span>
        <div className="tw-flex tw-items-start tw-gap-4 tw-self-stretch">
          <div className="tw-flex tw-flex-col tw-gap-1">
            <span className="tw-font-medium">Send update notifications</span>
            <span className="tw-text-xs tw-leading-4 tw-text-primary-grey">
              Update notifications will be sent in accordance with the guest&apos;s{' '}
              <a
                href="https://help.epochapp.com/articles/update-your-profile-and-settings"
                target="_blank"
                rel="noreferrer"
              >
                notification settings
              </a>
              .
            </span>
          </div>
          <Switch
            checked={sendNotifications}
            onCheckedChange={(checked) => setSendNotifications(checked)}
          />
        </div>
      </div>
      <ModalFooter className="tw-mt-0 tw-flex tw-flex-row tw-justify-end tw-gap-4 tw-text-black">
        <Button
          size="sm"
          onClick={navigation.onCancel}
          className="tw-rounded-xl"
          variant="secondary"
        >
          Cancel
        </Button>
        <Button
          size="sm"
          loading={navigation.loading}
          className="tw-rounded-xl"
          variant="primary"
          onClick={navigation.onClickSubmit}
        >
          Confirm
        </Button>
      </ModalFooter>
    </>
  );
};
